<template>
	<r-pop-menu
		ref="pop"
		class="pop"
		:openOnHover="true"
		:openOnHoverDelay="50"
		:closeOnHoverDelay="300"
		:closeOnContentClick="false"
		:relativeAlignmentActivator="0"
		:relativeAlignmentContainer="0.25"
		:spaceBetweenActivatorAndContent="0"
	>
		<div
			slot="activator" 
			class="explainer-pop-activator"
		>
			<slot></slot>
		</div>
		<div
			slot="content"
			class="explainer-pop-content"
		>
			<r-shadow 
				v-if="currentExplainer !== null"
				class="explainer-pop-outter"
				:height="2"
			>
				<div class="explainer-title">
					<r-standard-icon
						class="explainer-title-icon"
						:icon="currentIcon"
						color="green-300"
					></r-standard-icon>
					<div 
						class="explainer-title-text p-typography-regular-16"
						@pointerdown="ctaClicked"
					>
						{{ currentTitle }}
					</div>
				</div>
				<div 
					class="explainer-body"
				>
					<div class="explainer-top">
						<span class="explainer-body-text p-typography-regular-14">
							{{ currentBodyText }}
						</span>
						<span 
							class="explainer-body-cta p-typography-regular-14"
							@pointerdown="ctaClicked"
						>
							{{ currentCTAText }}
							<svg
								class="cta-arrow" 
								width="15" height="6" viewBox="0 0 15 6">
								<path d="M14.25 3L11.25 0V2.25H0V3.75H11.25V6L14.25 3Z" fill="#2FEDB4"/>
							</svg>
						</span>
					</div>
					<div 
						class="explainer-bottom"
						@pointerdown="ctaClicked"
					>
						<img 
							v-if="currentImage !== null"
							:src="currentImage" 
						/>
					</div>
				</div>
			</r-shadow>
		</div>	
	</r-pop-menu>
</template>

<script type="text/javascript">	

	import ExplainerConfig from 'vue/education/explainer-bubble/explainer-config';

	const explainerComputedProperties = {};

	ExplainerConfig.sortedExplainers.forEach(function withExplainer(explainerConfig){
		explainerComputedProperties['explainer_'+explainerConfig.key] = explainerConfig.criteria;
	});
	
	export default {
		components:{
		},
		data(){
			return {
				knowledgeGuideOpen: false,
			}
		},
		$pubsub:{
			knowledgeGuide:{
				subscriptions:{
					guideClosed(guideParams){
						const vcSelf = this;
						vcSelf.knowledgeGuideOpen = false;
						
					}
				}
			},
		},
		watch:{
			currentExplainer(){
				const vcSelf = this;
				if(vcSelf.currentExplainer !== undefined){
					if(vcSelf.userPrefrences !== undefined && vcSelf.explainerKey !== undefined){
						vcSelf.userPrefrences.explainer.explainerStates[vcSelf.explainerKey].dateLastShown = new Date().getTime();
					}
				}
			},
		},
		props:{
			explainerKey:{
				required: true,
			},
			sheetView:{
				required: true,
			},
		},
		computed: Object.assign(explainerComputedProperties, {
			currentExplainer(){
				const vcSelf = this;
				const foundExplainer = ExplainerConfig.sortedExplainers.find(function foundExplainerKey(explainerConfig){
					return explainerConfig.key === vcSelf.explainerKey;
				});
				if(foundExplainer){
					return foundExplainer;
				}
				else{
					return null;
				}
			},
			indexOfActive(){
				let returnIndex = null;
				if(this.explainerKey !== null){
					let found = false;
					returnIndex = 0;
					for(;returnIndex > ExplainerConfig.sortedExplainers.length;returnIndex++){
						if(ExplainerConfig.sortedExplainers[explainerIndex].key === this.explainerKey){
							found = true;
							break;
						}
					}
					if(!found){
						returnIndex = null;
					}
				}
				return returnIndex;
			},
			autoScope(){
				return this.$root.systemState.AutoScope;
			},
			userPrefrences(){
				if(this.autoScope.instance && this.autoScope.instance.objectInfo && this.autoScope.instance.objectInfo.userPreferences && this.autoScope.instance.objectInfo.userPreferences.status === "READY"){
					return this.autoScope.instance.objectInfo.userPreferences.value;
				}
				else{
					return null;
				}
			},
			currentIcon(){
				if(this.currentExplainer){
					return this.currentExplainer.icon;
				}
				else{
					return '';
				}
			},
			currentTitle(){
				if(this.currentExplainer){
					return this.currentExplainer.title;
				}
				else{
					return '';
				}
			},
			currentBodyText(){
				if(this.currentExplainer){
					return this.currentExplainer.hookText;
				}
				else{
					return '';
				}
			},
			currentCTAText(){
				if(this.currentExplainer){
					return this.currentExplainer.ctaText;
				}
				else{
					return '';
				}
			},
			currentImage(){
				if(this.currentExplainer){
					return this.currentExplainer.image;
				}
				else{
					return null;
				}
			},
		}),
		methods:{
			ctaClicked(){
				if(this.userPrefrences && this.explainerKey && this.currentExplainer){
					this.userPrefrences.explainer.explainerStates[this.explainerKey].engaged = true;
					this.currentExplainer.ctaOnClick.apply(this, [this.sheetView]);
					this.$refs.pop.closePop();
				}
				else{
					Assert.warn('The autoScope for userPreferences was not available in time to process the explainer action button.');
				}
			},

		}
	};

</script>

<style lang="scss" scoped>
.pop {
	position: relative;
	z-index: 100000;
}
.explainer-pop-outter{
	background-color: $p-color-blue-500;
	width: 306px;
	height: 249px;
	border-radius: 3px;
	padding: 15px 17px 18px 17px;

	.explainer-title{
		@include flex(row);
		margin: 0;
		margin-bottom: 12px;

		.explainer-title-icon{
			margin-right: 6px;
		}

		.explainer-title-text{
			color: $p-color-white;
			cursor: default;
			position: relative;
			top: 3px;
			user-select: none;
			flex-grow: 1;

		}

		.right-icons{
			@include flex(row);
			position: relative;
			top: 3px;
			height: 24px;

			.explainer-minimize-icon{

			}
			.explainer-expand-icon{
				margin-right: 9px;
			}
			.explainer-delete-icon{

			}
		}

	}
	.explainer-body{
		margin: 0;

		.explainer-top{
			margin-bottom: 21px;

			.explainer-body-text{
				color: $p-color-white;
				cursor: default;
			}
			.explainer-body-cta{
				@include clickable;
				color: $p-color-green-300;

				.cta-arrow{
					height: 9px;
				}
			}
		}

		.explainer-bottom{
			cursor: pointer;
		}
	}
}

</style>
